import { resolveChatBotSettings } from "@jugl-web/domain-resources/chat-bot/utils/resolveChatBotSettings";
import {
  DataLoadingWrapper,
  MultiSectionLayout,
} from "@jugl-web/ui-components";
import { getUniqueId } from "@jugl-web/utils";
import { useManageAccountsDrawer } from "@web-src/modules/client-support/pages/ClientSupportPage/components/ManageAccountsDrawer/providers/ManageAccountsDrawerContext";
import { ChatBotChannelPreview } from "@web-src/modules/client-support/pages/ClientSupportPage/components/ManageAccountsDrawer/screens/WebChatBotAccountScreen/components/WebChatBotAppearanceTab/components/ChatBotChannelPreview";
import { ChatbotPreviewBackground } from "@web-src/modules/client-support/pages/ClientSupportPage/components/ManageAccountsDrawer/screens/WebChatBotAccountScreen/components/WebChatBotAppearanceTab/components/ChatbotPreviewBackground";
import { FC, useState } from "react";
import { useAnonymousSession } from "@web-src/modules/auth/providers/AnonymousSessionProvider";
import { SetupAndTestTabMenu } from "./components/SetupAndTestTabMenu";
import { ReviseAnswerSidebar } from "./components/ReviseAnswerSidebar";

export const SetupAndTestTabContent: FC<{ entityId: string }> = ({
  entityId,
}) => {
  const { isAnonymous } = useAnonymousSession();
  const [revisePayload, setRevisePayload] = useState<{
    question: string;
    agentAnswer: string;
  }>();
  const { crmConfig, isCRMConfigLoading, isCRMConfigError, refetchCRMConfig } =
    useManageAccountsDrawer();
  const chatBotSettings = resolveChatBotSettings(crmConfig?.chatbot?.settings);

  return (
    <DataLoadingWrapper
      isLoading={isCRMConfigLoading}
      isError={isCRMConfigError}
      onRetry={refetchCRMConfig}
    >
      <MultiSectionLayout
        leftSide={<SetupAndTestTabMenu entityId={entityId} />}
        className="animate-fade-in"
        classNames={{
          content: "flex items-center justify-center",
        }}
      >
        <ChatbotPreviewBackground>
          <ChatBotChannelPreview
            entityId={entityId}
            chatName={chatBotSettings.chatName}
            agentName={chatBotSettings.agentName}
            welcomeMessage={chatBotSettings.welcomeMessage}
            senderMessageBackgroundColor={
              chatBotSettings.senderMessageBackgroundColor
            }
            theme={chatBotSettings.theme}
            buttonColor={chatBotSettings.buttonColor}
            alignment={chatBotSettings.alignment}
            bottomSpacing={chatBotSettings.bottomSpacing}
            sideSpacing={chatBotSettings.sideSpacing}
            chatImage={chatBotSettings.chatImageUrl}
            agentImage={chatBotSettings.agentImage}
            buttonIcon={chatBotSettings.buttonIcon}
            ctaVisual={chatBotSettings.ctaVisual?.url ?? null}
            ctas={chatBotSettings.ctas.map((item) => ({
              id: getUniqueId(),
              value: item,
            }))}
            suggestions={chatBotSettings.suggestions.map((item) => ({
              id: getUniqueId(),
              value: item,
            }))}
            chatMode="active"
            previewMode="chat-only"
            onRevise={!isAnonymous ? setRevisePayload : undefined}
          />
        </ChatbotPreviewBackground>
      </MultiSectionLayout>
      <ReviseAnswerSidebar
        entityId={entityId}
        isOpen={!!revisePayload}
        onRequestClose={() => setRevisePayload(undefined)}
        question={revisePayload?.question || ""}
        agentAnswer={revisePayload?.agentAnswer || ""}
      />
    </DataLoadingWrapper>
  );
};
